import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FindLoad, formatNumberToFix } from 'utils';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

const ACTON_TYPE = 'GET_COMPLETE_CLAIM_TOTALS';
export const CompletedTotals = ({}) => {
    const loader = FindLoad(ACTON_TYPE);
    const completedClaimTotals = useSelector((state) => state.claim.completedClaimTotals);

    if (loader?.length) {
        return (
            <div style={{ marginBottom: '-6px' }}>
                <Skeleton variant="rectangular" width={'100%'} height={66} style={{ borderRadius: '8px 8px 0px 0px' }} />
            </div>
        );
    }

    return (
        <div className="billing-total-box" style={{ gap: 16 }}>
            <div className="billing-total-row">
                <p className="billing-total-title">Total Billed:</p>
                <div className="billing-total-price-row">
                    <NumericFormat
                        // value={completedClaimTotals?.billedAmount ? completedClaimTotals?.billedAmount.toFixed(3) : 0}
                        value={completedClaimTotals?.billedAmount ? formatNumberToFix(completedClaimTotals?.billedAmount) : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                </div>
            </div>
            <div className="billing-total-row">
                <p className="billing-total-title">Total Allowed:</p>
                <div className="billing-total-price-row">
                    <NumericFormat
                        // value={completedClaimTotals?.allowedAmount ? completedClaimTotals?.allowedAmount.toFixed(3) : 0}
                        value={completedClaimTotals?.allowedAmount ? formatNumberToFix(completedClaimTotals?.allowedAmount) : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                </div>
            </div>
            <div className="billing-total-row">
                <p className="billing-total-title">Total Paid:</p>
                <div className="billing-total-price-row">
                    <NumericFormat
                        // value={completedClaimTotals?.paidAmount ? completedClaimTotals?.paidAmount.toFixed(3) : 0}
                        value={completedClaimTotals?.paidAmount ? formatNumberToFix(completedClaimTotals?.paidAmount) : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                </div>
            </div>
        </div>
    );
};
